import { App } from 'vue'
import {
  ElRadio,
  ElRadioGroup,
  ElCheckboxGroup,
  ElCheckbox,
  ElRadioButton,
  ElConfigProvider,
  ElDatePicker,
  ElInput,
  ElImage,
  ElTooltip,
  ElProgress,
  ElForm,
  ElFormItem,
  ElDescriptions,
  ElDescriptionsItem,
} from 'element-plus'

export default {
  install (app: App) {
    app.component(ElConfigProvider.name, ElConfigProvider)
    app.component(ElRadio.name, ElRadio)
    app.component(ElRadioGroup.name, ElRadioGroup)
    app.component(ElRadioButton.name, ElRadioButton)
    app.component(ElDatePicker.name, ElDatePicker)
    app.component(ElInput.name, ElInput)
    app.component(ElImage.name, ElImage)
    app.component(ElTooltip.name, ElTooltip)
    app.component(ElCheckboxGroup.name, ElCheckboxGroup)
    app.component(ElCheckbox.name, ElCheckbox)
    app.component(ElProgress.name, ElProgress)
    app.component(ElForm.name, ElForm)
    app.component(ElFormItem.name, ElFormItem)
    app.component(ElDescriptions.name, ElDescriptions)
    app.component(ElDescriptionsItem.name, ElDescriptionsItem)
  }
}
